export const FONTS = [
  'Press Start 2P',
  'VT323',
  'Bungee',
  'Russo One'
];
